import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
const pains = ['Esperando al electricista que nunca llega a horario', 'Pagando $25.000 por un enchufe que se cambia en 20 minutos', 'Sin saber qué hacer cuando salta la térmica a las 2 AM', 'Tablero sin etiquetar donde nadie sabe qué controla cada palanca', 'Diferencial que salta solo y nadie explica por qué', 'Aire acondicionado conectado en el circuito incorrecto desde hace años', 'Miedo a tocar cualquier cosa porque "la electricidad es peligrosa"'];
export function PainSection() {
  return <section className="pt-14 pb-0 relative overflow-hidden" data-id="element-409">
      <div className="container mx-auto px-4 relative z-10" data-id="element-410">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative max-w-3xl mx-auto mb-12" data-id="element-411">
          {/* Outer neon glow */}
          <div className="absolute -inset-1 bg-gradient-to-r from-red-500 via-red-400 to-red-500 rounded-3xl blur-xl opacity-40 animate-pulse" data-id="element-412"></div>

          {/* Frame */}
          <div className="relative bg-gradient-to-br from-graphite via-petroleum to-graphite border-2 border-red-500 rounded-3xl p-8 md:p-10 text-center overflow-hidden shadow-2xl shadow-red-500/30" data-id="element-413">
            {/* Grid pattern background */}
            <div className="absolute inset-0 opacity-[0.10] pointer-events-none" style={{
            backgroundImage: 'linear-gradient(rgba(239,68,68,0.7) 1px, transparent 1px), linear-gradient(90deg, rgba(239,68,68,0.7) 1px, transparent 1px)',
            backgroundSize: '24px 24px'
          }} data-id="element-414"></div>

            {/* Corner accents */}
            <div className="absolute top-0 left-0 w-16 h-16 border-t-4 border-l-4 border-red-500 rounded-tl-3xl pointer-events-none" data-id="element-415"></div>
            <div className="absolute top-0 right-0 w-16 h-16 border-t-4 border-r-4 border-red-500 rounded-tr-3xl pointer-events-none" data-id="element-416"></div>
            <div className="absolute bottom-0 left-0 w-16 h-16 border-b-4 border-l-4 border-red-500 rounded-bl-3xl pointer-events-none" data-id="element-417"></div>
            <div className="absolute bottom-0 right-0 w-16 h-16 border-b-4 border-r-4 border-red-500 rounded-br-3xl pointer-events-none" data-id="element-418"></div>

            <div className="relative z-10" data-id="element-419">
              <div className="inline-flex items-center gap-2 bg-red-500 text-white px-4 py-1.5 rounded-full text-xs font-extrabold uppercase tracking-wider mb-5 shadow-lg shadow-red-500/40" data-id="element-420">
                <XCircle className="w-3.5 h-3.5" data-id="element-421" />
                El Problema Real
              </div>
              <h2 className="text-3xl md:text-4xl font-extrabold mb-4" data-id="element-422">
                ¿Cuántos fines de semana más vas a esperar al{' '}
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-400 via-red-300 to-red-400 drop-shadow-[0_0_12px_rgba(239,68,68,0.4)]" data-id="element-423">
                  electricista?
                </span>
              </h2>
              <div className="mx-auto h-px w-32 bg-gradient-to-r from-transparent via-red-500 to-transparent opacity-70 mb-4" data-id="element-424"></div>
              <p className="text-lg text-textsecondary" data-id="element-425">
                Querés resolver los problemas de tu casa pero terminás
                dependiendo de alguien que llega tarde, cobra lo que quiere y no
                te explica nada.
                <br data-id="element-426" />
                <br data-id="element-427" />
                <span className="text-white font-medium" data-id="element-428">
                  No es falta de capacidad. Es falta de un sistema.
                </span>
              </p>
            </div>
          </div>
        </motion.div>

        <div className="max-w-4xl mx-auto grid gap-4 md:grid-cols-2" data-id="element-429">
          {pains.map((pain, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-petroleum p-5 rounded-xl border border-red-500/10 flex items-start gap-4 hover:border-red-500/30 transition-colors" data-id="element-430">
              <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-431" />
              <span className="text-textsecondary" data-id="element-432">{pain}</span>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mt-10" data-id="element-433">
          <h3 className="text-2xl md:text-3xl font-bold text-electric" data-id="element-434">
            ¿Y si este fuera el último fin de semana que pasás así?
          </h3>
        </motion.div>
      </div>
    </section>;
}